export const MINDEF_AUTH_URL = window.authUrl;
export const MINDEF_RESPONSE_TYPE = window.mindefCode;
export const MINDEF_CLIENT_ID = window.mindefClientId;
export const MINDEF_SCOPE = window.mindefScope;
export const MINDEF_REDIRECT_URI = window.mindefRedirectUri;

